// "… is live" dialog ke latakte taare — asli vector SVG (har zoom pe saaf).
//
// Pehle yahan /svg/stars-new.svg tha, jo andar se ek PNG tasveer hai — bada
// hone par dhundhli, aur uske taare alag-alag animate nahi ho sakte the.
// Ye usi artwork ki nakal hai: wahi teen doriyan + taare aur paanch chamak,
// wahi jagah (naap usi tasveer se liye gaye hain), wahi rang.
//
// Animation (HangingStars.module.css):
//   - har taara apni dori samet upar se utarta hai, phir lagataar jhoolta hai
//   - har taare pe thodi-thodi der me safed "shine" ki patti guzarti hai
//   - chamak (sparkles) lagataar timtimati hain
import React from "react";
import styles from "./HangingStars.module.css";

// Gol-kone wala paanch-kona taara: seedha polygon + usi rang ka mota gol
// stroke (strokeLinejoin="round") kono ko gol kar deta hai.
const starPoints = (cx, cy, radius) => {
  const inner = radius * 0.52;
  const points = [];
  for (let i = 0; i < 10; i += 1) {
    const r = i % 2 === 0 ? radius : inner;
    const angle = -Math.PI / 2 + (i * Math.PI) / 5;
    points.push(`${(cx + r * Math.cos(angle)).toFixed(2)},${(cy + r * Math.sin(angle)).toFixed(2)}`);
  }
  return points.join(" ");
};

// Chaar-kona chamak: andar ki taraf muda hua heera.
const sparklePath = (cx, cy, r) => {
  const k = r * 0.22;
  return [
    `M${cx} ${cy - r}`,
    `Q${cx + k} ${cy - k} ${cx + r} ${cy}`,
    `Q${cx + k} ${cy + k} ${cx} ${cy + r}`,
    `Q${cx - k} ${cy + k} ${cx - r} ${cy}`,
    `Q${cx - k} ${cy - k} ${cx} ${cy - r}Z`,
  ].join(" ");
};

// x = dori/taare ka beech, top = taare ka upari sira (dori yahan tak),
// cy = taare ka beech, r = taare ka bahari radius (stroke samet).
const STARS = [
  { id: "left", x: 27.1, top: 74.6, cy: 86.5, r: 12.3, color: "#FFC470", order: styles.hang2 },
  { id: "middle", x: 62.9, top: 34, cy: 50.2, r: 16.2, color: "#FFB13B", order: styles.hang1 },
  { id: "right", x: 103.9, top: 56.1, cy: 70.2, r: 13.5, color: "#FFC85C", order: styles.hang3 },
];

const SPARKLES = [
  { id: "orange", x: 10.1, y: 56.9, r: 4, color: "#FFAE2E" },
  { id: "teal", x: 37.9, y: 13.8, r: 3.5, color: "#5CC4B5" },
  { id: "blue", x: 89.1, y: 24.6, r: 6, color: "#45BFD0" },
  { id: "red", x: 63, y: 92.3, r: 4.8, color: "#FF6B74" },
  { id: "yellow", x: 117.1, y: 43.8, r: 4, color: "#FFD27A" },
];

const STROKE = 3.2;

const HangingStars = ({ className = "" }) => (
  <svg
    className={`${styles.stars} ${className}`}
    width="126"
    height="112"
    viewBox="0 0 126 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      {STARS.map((star) => (
        <clipPath key={star.id} id={`hangingStarClip-${star.id}`}>
          <polygon points={starPoints(star.x, star.cy, star.r)} />
        </clipPath>
      ))}
    </defs>

    {STARS.map((star) => (
      // .hang = upar se utarna; andar ka .swing = dori ke upari sire se jhoolna.
      <g key={star.id} className={`${styles.hang} ${star.order}`}>
        <g className={styles.swing} style={{ transformOrigin: `${star.x}px 0px` }}>
          <line
            x1={star.x}
            y1="-4"
            x2={star.x}
            y2={star.top + 2}
            stroke="#F9E0DA"
            strokeWidth="2.8"
            strokeLinecap="round"
          />
          <polygon
            points={starPoints(star.x, star.cy, star.r - STROKE / 2)}
            fill={star.color}
            stroke={star.color}
            strokeWidth={STROKE}
            strokeLinejoin="round"
          />
          {/* Shine: taare ke andar hi dikhne wali tirchhi safed patti. */}
          <g clipPath={`url(#hangingStarClip-${star.id})`}>
            <polygon
              className={styles.shine}
              style={{ "--shine-run": `${star.r * 2 + 16}px` }}
              points={[
                `${star.x - star.r - 8},${star.cy + star.r}`,
                `${star.x - star.r - 3},${star.cy + star.r}`,
                `${star.x - star.r + 5},${star.cy - star.r}`,
                `${star.x - star.r},${star.cy - star.r}`,
              ].join(" ")}
              fill="#fff"
            />
          </g>
        </g>
      </g>
    ))}

    {SPARKLES.map((sparkle) => (
      <path
        key={sparkle.id}
        className={styles.sparkle}
        d={sparklePath(sparkle.x, sparkle.y, sparkle.r)}
        fill={sparkle.color}
      />
    ))}
  </svg>
);

export default HangingStars;
